import React, { useState ,useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import FetchApi from '../customhooks/functionFetchApi'; 
import {useParams}from'react-router-dom';


const Quraityapproved = () => {
  const { id } = useParams();
  const FetchApis = new FetchApi();
  const navigate = useNavigate();
  const [form, setForm] = useState({ department: '', userconfirm: '', userconfirmName: '', product_group: '',groupcode: id });
  const [departmentFilter, setDepartmentFilter] = useState('');
  const [departmentOptions, setDepartmentOptions] = useState([{ depid:"", departmentname:"", departmentcode:"" }]);
  const [allUserConfirmOptions, setAllUserConfirmOptions] = useState([]);
  const [userConfirmOptions, setUserConfirmOptions] = useState([]);
  const [records, setRecords] = useState([]);
  const [editId, setEditId] = useState(null);
  
  const datatgroup=[
            "2pcs,Oval can",
            "3 pcs",
            "Normal end",
            "EOE/SOT",
            "Coated plate",
            "General can",
            "Dry foods can",
            "Aerosol can",
            "Coated plate"
        ]


   useEffect(() => {  
    fetchDepartmentOptions();
    fetchUserConfirmOptions();
     datapRecord();

   } , [])


   const fetchDepartmentOptions = () => {
    FetchApis.FethcGet(`/department/getdepartmentall`).then((res) => {
      if (res && res.data) {
          setDepartmentOptions(res.data.data);
      } 
    })
  };

  const fetchUserConfirmOptions = () => {
    FetchApis.FethcGet(`/account/accountall`).then((res) => {
      if (res && res.data) {
        const users = Array.isArray(res.data.data) ? res.data.data : [];
        setAllUserConfirmOptions(users);
        setUserConfirmOptions(users);
      }
    });
  };

  const datapRecord = () => {
    FetchApis.FethcGet(`/quarity/QuarityApprovedByGroupCode/${id}`).then((res) => {
      if (res &&res.data) {
        console.log('Fetch quality approved records:', res.data.data);
          setRecords(res.data.data);
      }
    }); 
  };

  const handleChange = (event) => {
    const { name, value } = event.target;

    if (name === 'departmentFilter') {
      const filteredUsers = value
        ? allUserConfirmOptions.filter((user) => user.departmentId === value)
        : allUserConfirmOptions;
      setDepartmentFilter(value);
      setUserConfirmOptions(filteredUsers);
      setForm((prev) => ({ ...prev, userconfirm: '', userconfirmName: '' }));
      return;
    }

    if (name === 'department') {
      setForm((prev) => ({ ...prev, department: value }));
      return;
    }

    if (name === 'userconfirm') {
      const selected = allUserConfirmOptions.find((user) =>
        (user.aId && user.aId.toString() === value.toString()) ||
        (user.username && user.username === value) ||
        (user.employeeId && user.employeeId.toString() === value.toString())
      );
      setForm((prev) => ({
        ...prev,
        userconfirm: value,
        userconfirmName: selected ? selected.name || selected.username || selected.employeeId : '',
      }));
      return;
    }

    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const resetForm = () => {
    // setForm({ department: '', userconfirm: '', userconfirmName: '', product_group: '' });
    setForm({ department: '', userconfirm: '', userconfirmName: '', product_group: '' });
    setDepartmentFilter('');
    setUserConfirmOptions(allUserConfirmOptions);
    setEditId(null);
    window.location.reload();
    
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!form.department || !form.userconfirm || !form.product_group.trim()) {
      return;
    }
    if (editId !== null) {
      console.log(form.id, form.department, form.userconfirm, form.product_group);

      FetchApis.FethcUpdate(`/quarity/UpdateTdsQuarityApproved/${editId}`, {
        departmentId: form.department,
        userConfirm: form.userconfirm,
        product_group: form.product_group,
      }).then((res) => {
        console.log('Update quality approved:', res); 
      });


      setRecords((prev) => prev.map((item) => item.qaId === editId ? {
        ...item,
        department: form.department,
        userconfirm: form.userconfirm,
        product_group: form.product_group,
      } : item));
      resetForm();
      return;
    }

    const newRecord = {
      id: form.qaId,
      department: form.department,
      userconfirm: form.userconfirm,
      userconfirmId: form.userconfirm,
      product_group: form.product_group,
      groupcode: form.groupcode,
    };

    FetchApis.FethcPost(`/quarity/CreatetdsQuarityApproved`, {
      departmentId: newRecord.department,
      userConfirm: newRecord.userconfirmId,
      product_group: newRecord.product_group,
      groupcode: newRecord.groupcode,
    }).then((res) => {
      console.log('Create quality approved:', res);
    });

    setRecords((prev) => [newRecord, ...prev]);
    resetForm();
  };

  const handleEdit = (row) => {
    setForm({
      department: row.department,
      userconfirm: row.userconfirmId || row.userconfirm,
      userconfirmName: row.userconfirm || '',
      product_group: row.product_group,
    });
    const filteredUsers = row.department
      ? allUserConfirmOptions.filter((user) => user.departmentId === row.department)
      : allUserConfirmOptions;
    setUserConfirmOptions(filteredUsers);
    setDepartmentFilter(row.department || '');
    setEditId(row.qaId);
  };

  const handleDelete = (rowId) => {

      FetchApis.FethcDelete(`/quarity/DeleteTdsQuarityApproved/${rowId}`).then((res) => {
        console.log('Delete quality approved:', res);
      });

    setRecords((prev) => prev.filter((item) => item.qaId !== rowId));
    if (editId === rowId) {
      resetForm();
    }

  };

  const getDepartmentName = (departmentId) => {
    const option = departmentOptions.find((item) => item.departmentcode === departmentId);
    return option ? option.departmentname : 'ไม่ระบุแผนก';
  };


  const groupedUserConfirmOptions = userConfirmOptions.reduce((groups, user) => {
    const groupName = getDepartmentName(user.departmentId);
    if (!groups[groupName]) {
      groups[groupName] = [];
    }
    groups[groupName].push(user);
    return groups;
  }, {});

  const columns = [
    {
      name: 'departments',
      selector: (row) => row.departments,
      sortable: true,
      grow: 2,
    },
    {
      name: 'nameUser',
      selector: (row) => row.nameUser,
      sortable: true,
      grow: 2,
    },
    {
      name: 'product_group',
      selector: (row) => row.product_group,
      sortable: true,
      grow: 3,
    },
    {
      name: 'จัดการ',
      cell: (row) => (
        <div style={{ display: 'flex', gap: '8px' }}>
          <button
            type="button"
            onClick={() => handleEdit(row)}
            style={{ padding: '6px 10px', borderRadius: '4px', border: '1px solid #1976d2', background: '#1976d2', color: '#fff', cursor: 'pointer' }}
          >
            แก้ไข
          </button>
          <button
            type="button"
            onClick={() => handleDelete(row.qaId)}
            style={{ padding: '6px 10px', borderRadius: '4px', border: '1px solid #e53935', background: '#fff', color: '#e53935', cursor: 'pointer' }}
          >
            ลบ
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: '180px',
    },
  ];

  return (
    <div style={{ padding: '24px', maxWidth: '980px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
        <div>
          <h2>Quality Approved</h2>
          <p style={{ margin: 0 }}>สร้างรายการด้วยฟอร์มสำหรับ department, userconfirm, product_group แล้วแสดงในตาราง</p>
        </div>
        <button
          type="button"
          onClick={() => navigate('/quaritygroup')}
          style={{ padding: '10px 18px', borderRadius: '4px', border: '1px solid #1976d2', background: '#fff', color: '#1976d2', cursor: 'pointer' }}
        >
          กลับไป Quaritygroup
        </button>
      </div>

      <form onSubmit={handleSubmit} style={{ display: 'grid', gap: '16px', marginBottom: '24px' }}>
        <div style={{ display: 'grid', gap: '8px' }}>
          <label htmlFor="department">department</label>
          <select
            id="department"
            name="department"
            value={form.department}
            onChange={handleChange}
            style={{ padding: '10px', borderRadius: '4px', border: '1px solid #ccc' }}
          >
            <option value="">เลือก department</option>
            {departmentOptions.map((option) => (
              <option key={option.departmentcode} value={option.departmentcode}>{option.departmentname}</option>
            ))}
          </select>
        </div>

        <div style={{ display: 'grid', gap: '8px' }}>
          <label htmlFor="departmentFilter">ค้นหา userconfirm ตามแผนก</label>
          <select
            id="departmentFilter"
            name="departmentFilter"
            value={departmentFilter}
            onChange={handleChange}
            style={{ padding: '10px', borderRadius: '4px', border: '1px solid #ccc' }}
          >
            <option value="">ทั้งหมด</option>
            {departmentOptions.map((option) => (
              <option key={option.departmentcode} value={option.departmentcode}>{option.departmentname}</option>
            ))}
          </select>
        </div>

        <div style={{ display: 'grid', gap: '8px' }}>
          <label htmlFor="userconfirm">userconfirm</label>
          <select
            id="userconfirm"
            name="userconfirm"
            value={form.userconfirm}
            onChange={handleChange}
            style={{ padding: '10px', borderRadius: '4px', border: '1px solid #ccc' }}
          >
            <option value="">เลือก userconfirm</option>
            {Object.entries(groupedUserConfirmOptions).map(([groupName, users]) => (
              <optgroup key={groupName} label={groupName}>
                {users.map((option) => (
                  <option key={option.aId || option.username || option.employeeId} value={option.aId || option.username || option.employeeId}>
                    {option.name || option.username || option.employeeId}
                  </option>
                ))}
              </optgroup>
            ))}
          </select>
        </div>

        <div style={{ display: 'grid', gap: '8px' }}>
          <label htmlFor="product_group">product group</label>
          <select
            id="product_group"
            name="product_group"
            value={form.product_group}
            onChange={handleChange}
            style={{ padding: '10px', borderRadius: '4px', border: '1px solid #ccc' }}
          >
            <option value="">เลือก product group</option>
            {datatgroup.map((item) => (
              <option key={item} value={item}>{item}</option>
            ))}
          </select>
        </div>

        <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
          <button
            type="submit"
            style={{ padding: '10px 18px', borderRadius: '4px', background: '#1976d2', color: '#fff', border: 'none', cursor: 'pointer' }}
          >
            {editId !== null ? 'อัปเดต' : 'บันทึก'}
          </button>
          {editId !== null && (
            <button
              type="button"
              onClick={resetForm}
              style={{ padding: '10px 18px', borderRadius: '4px', border: '1px solid #ccc', background: '#f5f5f5', cursor: 'pointer' }}
            >
              ยกเลิก
            </button>
          )}
        </div>
      </form>

      <div>
        <h3>รายการ Quality Approved</h3>
        <DataTable
          columns={columns}
          data={records}
          noHeader
          responsive
          pagination
          highlightOnHover
          pointerOnHover
          dense
          striped
          noDataComponent={<div style={{ padding: '16px' }}>ยังไม่มีรายการ</div>}
        />
      </div>
    </div>
  );
};

export default Quraityapproved;
